import Vue from 'vue';
import axios from "axios";

// const BASE_URL='http://192.168.100.13:8085' // 测试地址
// const BASE_URL='http://39.105.130.236:8081' // 正式环境
const BASE_URL='http://honglijc.cn/cloud' // 正式环境
axios.interceptors.request.use(config => {
    var token = sessionStorage.getItem("token");
    if (token && token != "") {
        config.headers['token'] =token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

axios.defaults.timeout = 120000; // 在超时时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 配置请求头
axios.defaults.baseURL = BASE_URL; 
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;